import { ReactElement } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'antd/dist/reset.css';
import { HelmetProvider } from 'react-helmet-async';

import '@/styles/custom-styles.scss';
import '@/styles/reset.scss';

import AppRouter from './router';

const queryClient = new QueryClient();

function App(): ReactElement {
	return (
		<div className="app">
			<HelmetProvider>
				<QueryClientProvider client={queryClient}>
					<AppRouter />
				</QueryClientProvider>
			</HelmetProvider>
		</div>
	);
}

export default App;
